export default "__VITE_ASSET__Dlwkm3im__"